export default __webpack_public_path__ + "static/media/_ic_doc.0414af52.svg";